import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: grid;
  grid-template-rows: 59px 1fr;
  align-items: stretch;
  min-height: fill-available;
  width: 100%;
`;
